<div class="container-simple-thumbs">
  @if ({
    thumbs: thumbs$ | async,
    config: corrouselConfig$ | async,
    }; as content) {
    @if (product$ | async; as product) {
      @if (content.thumbs?.length) {
        <div class="container-thumbs-carousel m-t-20">
          <p-carousel
            role="region"
            [attr.aria-label]="'carousel.carouselForProduct' | cxTranslate: { product: product.name }"
            [value]="content.thumbs ?? []"
            [numVisible]="4"
            [numScroll]="4"
            [circular]="content.config?.circular ?? true"
            [showIndicators]="content.config?.showIndicators ?? true"
            [showNavigators]="content.config?.showNavigators ?? true"
            [autoplayInterval]="content.config?.autoplayInterval ?? 0"
            [classList]="'custom-carousel product-carousel thumbs-carousel'"
            [responsiveOptions]="responsiveOptions"
            >
            <ng-template pTemplate="item" let-item>
              @if (item | async; as item) {
                <ng-container *ngTemplateOutlet="thumb; context: { item }"> </ng-container>
              }
            </ng-template>
            <ng-template pTemplate="previousicon" let-item>
              <span class="material-symbols-outlined text-primary"> arrow_back_ios </span>
            </ng-template>
            <ng-template pTemplate="nexticon" let-item>
              <span class="material-symbols-outlined text-primary m-l-12"> arrow_forward_ios </span>
            </ng-template>
          </p-carousel>
        </div>
      }
    }
  }

  <ng-template #thumb let-item="item">
    <div
      #containerThumb
      [ngStyle]="item.type === GALLERY_MEDIA_TYPE.VIDEO ? { 'background-image': 'url(' + getThumbVideo(item.content) + ')' } : {}"
      class="js-thumb thumb type-{{ item.type }}"
      [ngClass]="{ 'is-active': checkIsActive(item) }"
      (click)="setContent(item)"
      (keyup.enter)="setContent(item)"
      [attr.tabindex]="0"
      >
      @if (item.type === GALLERY_MEDIA_TYPE.IMAGES) {
        <cx-media [container]="item.content" tabindex="0" format="product"> </cx-media>
      }

      @if (item.type === GALLERY_MEDIA_TYPE.VIDEO) {
        <span class="d-flex icon material-symbols-outlined"> play_circle </span>
      }

      @if (item.type === GALLERY_MEDIA_TYPE.IMAGE_360) {
        <div class="icon-360">
          <img [src]="item.content.normal.split(' ')[0]" alt="" />

          <div class="box-icon">
            <div class="icon">
              <span class="d-flex material-symbols-outlined"> 360 </span>
              <span class="text">360°</span>
            </div>
          </div>
        </div>
      }
    </div>
  </ng-template>
</div>
